import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'
import { FileDetailPage } from '@/src/components/manage/views/FileDetailPage'

export const Route = createFileRoute('/_manage/manage/files/$shareId')({
  component: ViewFilePage,
})

function ViewFilePage() {
  const { shareId } = useParams({ from: '/_manage/manage/files/$shareId' })
  return <FileDetailPage shareId={shareId} backTo="/manage/files" />
}
